import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import influencer1829Webp from '@/assets/landing-age-selection/influencer-walking-18-29.webp'
import influencer3039Webp from '@/assets/landing-age-selection/influencer-walking-30-39.webp'
import influencer4049Webp from '@/assets/landing-age-selection/influencer-walking-40-49.webp'
import influencer5059Webp from '@/assets/landing-age-selection/influencer-walking-50-59.webp'

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'walking_influencer',
	},
	order: ['LandingLanguageButton', 'LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_walking.pages.landing.step_1.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: $t('female_activity.pages.landing.step_1.options.18_29'),
					img: influencer1829Webp,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: $t('female_activity.pages.landing.step_1.options.30_39'),
					img: influencer3039Webp,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: influencer4049Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: influencer5059Webp,
				},
			],
			otherAgesButton: {
				data: { value: 60, analyticValue: '60-80' },
				text: "I'm 60-80",
			},
		}),
	},
}

export default schema
